import PreUndoData from "./PreUndoData";

export default class DeleteTrackData extends PreUndoData {
    addUndoCommand: boolean|null = null
    constructor(trackId: string, addUndoCommand: boolean|null = null) {
        super()
        this.trackId = trackId // doesn't need to be cloned as it's a trivial type. Any arrays/objects should be cloned
        this.addUndoCommand = addUndoCommand
    }
    trackId: string
}